/**
 * Compiles the turso wasm, refetching once when the download breaks. Chrome rejects `compileStreaming` with a
 * TypeError ("WebAssembly compilation aborted: Network error: Response body loading was aborted") when the 19.9 MB
 * body is cut. Prior art: turso-fts's own napi glue `instantiateStreaming(...).catch(() => fetch again)`. Any other
 * error (CompileError, LinkError) is a bad module and is not retried. The bundle exports no wasm URL
 * (`export{...Uc as compileWasm...}`), so the retry goes through its `compileWasm` again rather than an ArrayBuffer path.
 */
export function compileTursoWasm(compileWasm: () => Promise<WebAssembly.Module>): Promise<WebAssembly.Module> {
  return compileWasm().catch((error: unknown) => {
    if (!(error instanceof TypeError)) throw error
    return compileWasm()
  })
}
